const FETCH_PLANT = 'FETCH_PLANT';
const HANDLE_REFRESH_PLANT = 'HANDLE_REFRESH_PLANT';
const MANAGE_ELIOT_PARSE_EXCEPTION = 'MANAGE_ELIOT_PARSE_EXCEPTION';
const AUTOMATION_WIZARD_NEXT_CALLED = 'AUTOMATION_WIZARD_NEXT_CALLED';

export {
  FETCH_PLANT,
  HANDLE_REFRESH_PLANT,
  MANAGE_ELIOT_PARSE_EXCEPTION,
  AUTOMATION_WIZARD_NEXT_CALLED,
};
